import React from 'react';

const Wand2Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m3 21 8.8-8.8a3 3 0 0 1 4.2 0l0 0a3 3 0 0 1 0 4.2L7.2 20.8a3 3 0 0 1-4.2 0l0 0a3 3 0 0 1 0-4.2Z" />
    <path d="m14.5 7.5 4-4" />
    <path d="M6 6h.01" />
    <path d="M21 21h.01" />
    <path d="M.5 13.5h.01" />
    <path d="M10 3.5v.01" />
  </svg>
);

export default Wand2Icon;